module.exports = __webpack_public_path__ + "media/application/images/svgs/bookmark-e66d2c9f1a9aea62bf3db618b22955fb.svg";